import { Injectable } from '@angular/core';
import { Observable, map, tap } from 'rxjs';
import { ApiService } from './api.service';
import { StorageService } from './storage.service';
import { RegistrationDto } from '../models/registration.dto';
import { User } from '../models/user';
import { ApiResponse } from '../models/api-response';
import { RegisterResult } from '../models/register-result';
import { LoginResult } from '../models/login-result';

@Injectable({ providedIn: 'root' })
export class AuthService {
  constructor(
    private api: ApiService,
    private storage: StorageService,
  ) {}

  register(dto: RegistrationDto): Observable<RegisterResult> {
    return this.api.post<ApiResponse<RegisterResult>>('/customer', dto).pipe(
      map(res => {
        if (!res.data) {
          throw new Error(res.message || 'Registration did not return data');
        }
        return res.data;
      })
    );
  }

  verifyCustomer(id: string, code: string): Observable<RegisterResult> {
    console.log('verifyCustomer called with', id, code);

    return this.api.get<ApiResponse<RegisterResult>>(`/customer/${id}/verify/${code}`).pipe(
      map(res => {
        console.log('verifyCustomer response', res);

        if (!res.data) {
          throw new Error(res.message || 'Verification did not return data');
        }
        return res.data;
      })
    );
  }

  login(email: string, password: string): Observable<LoginResult> {
    return this.api.post<ApiResponse<LoginResult>>('/auth/login', { email, password }).pipe(
      map(res => {
        if (!res.data) {
          throw new Error(res.message || 'Login did not return data');
        }
        return res.data;
      }),
      tap(loginResult => {
        this.storage.setToken(loginResult.token);
        this.storage.setUser({
          id: loginResult.userId,
          email: loginResult.email,
        });
      })
    );
  }

  logout(): void {
    this.storage.clear();
  }

  getToken(): string | null {
    return this.storage.getToken();
  }

  getCurrentUser(): User | null {
    return this.storage.getUser();
  }

  isAuthenticated(): boolean {
    const token = this.getToken();
    if (!token) return false;

    if (this.isTokenExpired(token)) {
      this.logout();
      return false;
    }

    return true;
  }

  isTokenExpired(token: string): boolean {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const exp = payload.exp * 1000; // seconds → ms
      return Date.now() > exp;
    } catch {
      return true;
    }
  }
}
